var axios = require('axios')
const urlSlice = process.env.version + '/product-customer/slice_info'
const urlSliceHistory = process.env.version + '/product-customer/slice_grant_history'
const urlSliceExpired = process.env.version + '/product-customer/slice_expired'
const urlEvent = process.env.version + '/product-customer/jp-loyalty-events'

const getVersionedUrl = (params) => {
    if (typeof params === 'string') {
      params = params.split('&').reduce((acc, part) => {
        const [key, value] = part.split('=');
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
    }

    // const outletCode = params.outlet_code
    // const menuV4Stores = JSON.parse(localStorage.getItem('jp_use_menu_v4_api_stores')) || []
    // let version = process.env.version2;
    // console.log(menuV4Stores, params, 'menuV4Stores')
    
    // Default to v4 API for all stores, unless specified otherwise in localStorage
    let version = process.env.version4;
    // if (menuV4Stores.includes(outletCode)) {
    //     console.log("Using v4 API")
    //     version = process.env.version4;
    // } else {
    //     console.log("Using v2 API")
    // }

    const urlCategory = version + '/product-menu-fe/category'
    const urlMenu = version + '/product-menu-fe/menu'

    return {
      urlMenu,
      urlCategory,
    }
} 

axios.getCategoryLoyalty = function (params, success, callBackError) {
  var urlCategory = getVersionedUrl(params).urlCategory;

  this.get(urlCategory, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getAllCategoryLoyalty = async function (params) {
  var urlCategory = getVersionedUrl(params).urlCategory;

  try {
    const result = await this.get(urlCategory, {params})
    if (result.status === 200 && result.data) {
      return result
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

axios.getFreeItemsLoyalty = async function (params) {
  var urlMenu = getVersionedUrl(params).urlMenu;

  try {
    const result = await this.get(urlMenu, {params})
    if (result.status === 200 && result.data) {
      return result
    }
  } catch (error) {
    console.log(error)
  }
  return null
}

axios.getItemsLoyalty = function (params, success, callBackError) {
  var urlMenu = getVersionedUrl(params).urlMenu;

  this.get(urlMenu, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceInfo = function (params, success, callBackError) {
  this.get(urlSlice, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceHistory = function (params, success, callBackError) {
  this.get(urlSliceHistory, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getEventLoyalty = function (params, success, callBackError) {
  this.get(urlEvent, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.deleteEventLoyalty = function (params, success, callBackError) {
  this.delete(urlEvent + '/' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getSliceExpired = function (params, success, callBackError) {
  this.get(urlSliceExpired, {params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Loyalty.js